import React from 'react';
import WhatsAppPage from './WhatsAppPage';

/**
 * Reusable fragment that renders the full WhatsApp chat UI (the old WhatsAppPage)
 * in an embedded mode suitable for the vendor preview panels.
 */
export default function WhatsAppChatFragment({ vendor, phone }) {
  return (
    <div className="arcam-chat-panel h-[600px] w-full rounded-xl border border-neutral-200 shadow-sm overflow-hidden flex flex-col">
      <WhatsAppPage embedded preselectPhone={phone} />
    </div>
  );
}
